// extracted by mini-css-extract-plugin
export default {"link":"link_link__Sjdpi","center":"link_center__fJL63","block":"link_block__5M9SR","bold":"link_bold__J4VjG","white":"link_white__OOj40","muted":"link_muted__bzMLz"};